"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Steps = function (_a) {
    var step = _a.step, stepsCount = _a.stepsCount, setActiveStep = _a.setActiveStep;
    var steps = (0, react_1.useMemo)(function () {
        var stepsArray = [];
        for (var i = 0; i < stepsCount; i++) {
            stepsArray.push({
                step: i,
                highlight: step === i,
            });
        }
        return stepsArray;
    }, [step, stepsCount]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, steps.map(function (item, idx) { return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.step, " ").concat(item.highlight ? styles_module_scss_1.default.active : ''), key: "stepDigestView".concat(idx), onClick: function () { return setActiveStep(idx); } }, item.step + 1)); })));
};
exports.default = react_1.default.memo(Steps);
